import { animate, MotionValue, useDragControls } from 'framer-motion';
import { useCallback, useState } from 'react';

export type BottomSheetDragOptions = {
  onClose: () => void;
  closeDistance?: number; // px
  closeVelocity?: number; // px/s
  snapSpring?: { stiffness?: number; damping?: number; mass?: number };
  y: MotionValue<number>;
};

export function useBottomSheetDrag({ onClose, y, closeDistance = 56, closeVelocity = 600, snapSpring = { stiffness: 420, damping: 32, mass: 0.8 } }: BottomSheetDragOptions) {
  const controls = useDragControls();
  const [dragging, setDragging] = useState(false);

  const onDragStart = useCallback(() => {
    setDragging(true);
  }, []);

  const onDrag = useCallback(
    (_: any, info: { offset: { y: number } }) => {
      const offsetY = info.offset.y;
      y.set(Math.max(0, offsetY));
    },
    [y]
  );

  const onDragEnd = useCallback(
    (_: MouseEvent | TouchEvent | PointerEvent, info: { offset: { y: number }; velocity: { y: number } }) => {
      setDragging(false);
      const dragged = info.offset.y;
      const velocity = info.velocity.y;
      if (dragged > closeDistance || velocity > closeVelocity) {
        onClose();
      } else {
        animate(y, 0, { type: 'spring', ...snapSpring });
      }
    },
    [closeDistance, closeVelocity, onClose, snapSpring, y]
  );

  return {
    controls,
    y,
    dragging,
    onDragStart,
    onDrag,
    onDragEnd,
  };
}
